// Partner, retailer, and store-configuration IDs come from URL path params. Unresolved scopes may
// use '0'/'-1', and malformed URLs can contain the literal 'undefined'. These IDs can cause failed
// requests, so callers must skip rather than fire the query. Real scope IDs are positive integers.
export const isValidScopeId = (id?: string): boolean => id != null && Number(id) > 0
